// Handlers
import { WebsocketTimeoutHandlers } from 'handlers/websocket.timeout.handlers';
// Types
import {
  IframeSocketBuilderHandlersType,
  IframeSocketMethodsHandlersType,
  IframeSocketSendBuilderHandlersType,
  StartWhenSockedAndFrameLoadedEventHandlerType,
} from './types/iframe-socket.handlers.type';

const startWhenSockedAndFrameLoadedEventHandler = ({
  handleDisconnectWebSocketFromChannelEvent,
  handleConnectWebSocketChannelEvent,
  frameLoaded,
  fetching,
  onError,
  onReceiveData,
  timeoutRef,
  setError,
}: StartWhenSockedAndFrameLoadedEventHandlerType): (() => void) | undefined => {
  if (frameLoaded && !fetching) {
    handleConnectWebSocketChannelEvent({ onError, onReceiveData });
    const { handleFinalizeWs, handleStartWsTimeout } = WebsocketTimeoutHandlers({
      handleDisconnectWebSocketFromChannelEvent,
      setError,
      timeoutRef,
    });
    timeoutRef.current = handleStartWsTimeout();
    return () => {
      handleFinalizeWs();
    };
  }
};

const sendMessageWhenWebSockedAndFrameLoadedEventHandler = async ({
  frameLoaded,
  handleSendWebSocketMessageEvent,
  webSocketMessage,
  websocketConnected,
}: IframeSocketSendBuilderHandlersType): Promise<void> => {
  Boolean(websocketConnected && frameLoaded) && handleSendWebSocketMessageEvent(webSocketMessage);
};

const IframeSocketHandlers = ({
  handleSendWebSocketMessageEvent,
  handleDisconnectWebSocketFromChannelEvent,
  webSocketMessage,
  handleConnectWebSocketChannelEvent,
  websocketConnected,
  frameLoaded,
  fetching,
  onError,
  onReceiveData,
  setError,
  timeoutRef,
}: IframeSocketBuilderHandlersType): IframeSocketMethodsHandlersType => ({
  handleSendMessageWhenWebSockedAndFrameLoadedEvent: () => {
    sendMessageWhenWebSockedAndFrameLoadedEventHandler({
      frameLoaded,
      handleSendWebSocketMessageEvent,
      webSocketMessage,
      websocketConnected,
    });
  },
  handleStartWhenSockedAndFrameLoadedEvent: () =>
    startWhenSockedAndFrameLoadedEventHandler({
      handleDisconnectWebSocketFromChannelEvent,
      handleConnectWebSocketChannelEvent,
      frameLoaded,
      fetching,
      onError,
      onReceiveData,
      timeoutRef,
      setError,
    }),
});

export { IframeSocketHandlers };
